import { render } from "./UserAvatar.vue?vue&type=template&id=69a6b65e"
import script from "./UserAvatar.vue?vue&type=script&lang=js"
export * from "./UserAvatar.vue?vue&type=script&lang=js"

import "./UserAvatar.vue?vue&type=style&index=0&id=69a6b65e&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__